import NavigationMenu from "../components/NavigationMenu"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useRef, useEffect } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

const AboutUs = () => {
  let hiddenColumnRef = useRef(null);
  let fixedColumnRef = useRef(null);
  let scrollableContentRef = useRef(null);
  let observerRefValue = hiddenColumnRef.current;

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      let width = Math.floor(entries[0].contentRect.width);

      if (fixedColumnRef.current == null) { return; }
      if (width > 0) {
        fixedColumnRef.current.style.width = width - 20 + 'px';
        scrollableContentRef.current.style.width = width - 60 + 'px';
        fixedColumnRef.current.style.position = 'fixed';
      }
    });
    observer.observe(hiddenColumnRef.current);
    return () => observerRefValue && observer.unobserve(observerRefValue);
  });

  return (
    <>
      <div ref={fixedColumnRef} className='d-none d-md-block options-bar-fixed'>
        <div className="flex-container">
          <Scrollbars>
            <div className='scrollable'>
              <div></div>
              <div ref={scrollableContentRef}>
                <br />
                <NavigationMenu />
              </div>
            </div>
          </Scrollbars>
        </div>
      </div>

      <Row>
        <Col ref={hiddenColumnRef} xs={4} className='d-none d-md-block'></Col>
        <Col xs={12} md={8}>
          <br/>

          <div className='container-home-feed '>

              <div>
                <h5>Quienes somos</h5>
                <br/>
                <p>
                  En BuscaTuAuto creemos que buscar un auto debería ser simple, transparente y sin perder tiempo. Por eso creamos un buscador inteligente de vehículos en Chile que reúne avisos de distintas plataformas en un solo lugar, para que compares y decidas mejor.
                </p>
                <p>
                  Nuestro objetivo es ayudarte a encontrar el auto ideal según lo que realmente importa: precio, año, kilometraje, ubicación, estado y características reales. Sin duplicados, sin ruido y con información clara.
                </p>
              </div>

              <div style={{ marginTop: '30px' }}>
                <h5>Qué hacemos</h5>
                <ul>
                  <li>Centralizamos avisos de compra y venta de autos desde múltiples fuentes.</li>
                  <li>Normalizamos y ordenamos la información para que puedas comparar fácilmente.</li>
                  <li>Actualizamos constantemente los datos para mostrar resultados relevantes.</li>
                </ul>
              </div>

              <div style={{ marginTop: '30px' }}>
                <h5>Nuestra visión</h5>
                <p>
                  Queremos convertirnos en el referente número uno en Chile para la búsqueda de autos, entregando una experiencia rápida, confiable y enfocada en el usuario.
                </p>
              </div>

              <div style={{ marginTop: '30px' }}>
                <h5>Independencia y transparencia</h5>
                <p>
                  BuscaTuAuto no vende vehículos ni intermedia en las operaciones. Somos una plataforma independiente cuyo valor está en la información y en la experiencia de búsqueda. La decisión final siempre es tuya.
                </p>
              </div>

              <div style={{ marginTop: '30px' }}>
                <h5>Por qué BuscaTuAuto</h5>
                <p>
                  Porque tu tiempo vale, y creemos que encontrar un auto no debería ser complicado.
                </p>
                <p style={{ marginTop: '15px', fontSize: '1.1em', fontWeight: '500' }}>
                  🚗🔍 BuscaTuAuto — busca, compara y elige mejor.
                </p>
              </div>

          </div>


        </Col>
      </Row>
    </>
  )
};

export default AboutUs;